'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_UPDATE_SCROLL_POSITION = exports.GET_CHANNEL_INFO_FAILURE = exports.GET_CHANNEL_INFO_END = exports.GET_CHANNEL_INFO_START = exports.GET_SEARCH_FAILURE = exports.GET_SEARCH_COMPLETE = exports.GET_SEARCH_START = undefined;
exports.getSearchResults = getSearchResults;
exports.updateScrollPosition = updateScrollPosition;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var GET_SEARCH_START = exports.GET_SEARCH_START = 'GET_SEARCH_START';
var GET_SEARCH_COMPLETE = exports.GET_SEARCH_COMPLETE = 'GET_SEARCH_COMPLETE';
var GET_SEARCH_FAILURE = exports.GET_SEARCH_FAILURE = 'GET_SEARCH_FAILURE';
var GET_CHANNEL_INFO_START = exports.GET_CHANNEL_INFO_START = 'GET_CHANNEL_INFO_START';
var GET_CHANNEL_INFO_END = exports.GET_CHANNEL_INFO_END = 'GET_CHANNEL_INFO_COMPLETE';
var GET_CHANNEL_INFO_FAILURE = exports.GET_CHANNEL_INFO_FAILURE = 'GET_CHANNEL_INFO_FAILURE';
var SEARCH_UPDATE_SCROLL_POSITION = exports.SEARCH_UPDATE_SCROLL_POSITION = 'SEARCH_UPDATE_SCROLL_POSITION';

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------
var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Token ' + state.auth.authInfo.access_token;
    }

    return header;
}

/**
 * Retrieves channel information for the contentsIds returned in the searchResults
 * @param searchResults Results from the query to Search Execution Services (SES)
 */
function getChannelInfo(searchResults) {
    return function (dispatch, getState) {
        if (searchResults && searchResults.numOfResults && searchResults.numOfResults > 0) {
            var header = { 'Content-Type': 'application/json' };
            var contentKeys = [];

            searchResults.results.forEach(function (result) {
                contentKeys.push(result.id);
            });

            var reqUrl = baseUrl() + '/channels?query=contentKey:=' + contentKeys.join();

            dispatch({ type: GET_CHANNEL_INFO_START });

            HTTP.getData(reqUrl, header).then(function (response) {
                dispatch({
                    type: GET_CHANNEL_INFO_END,
                    channelInfo: response,
                    channelMetadataResolved: true
                });
                return Promise.resolve(response);
            }).catch(function (error) {
                dispatch({
                    type: GET_CHANNEL_INFO_FAILURE,
                    channelInfoError: error
                });
                throw error;
            });
        }
    };
}

function getSearchResults(query) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var clearSearchResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var reqUrl = baseUrl() + '/search';

    return function (dispatch, getState) {
        // If no search string, then just resolve & dont query the api
        if (!query) {
            return Promise.resolve();
        }

        var store = getState();
        var header = getheader(store);
        var reqBody = {
            q: query,
            page: page,
            size: 25
        };
        dispatch({ type: GET_SEARCH_START, newQuery: query, clearSearchResults: clearSearchResults });

        return HTTP.postData(reqUrl, header, reqBody).then(function (searchResults) {
            dispatch({
                type: GET_SEARCH_COMPLETE,
                searchResults: searchResults,
                searchQuery: query
            });
            dispatch(getChannelInfo(searchResults));
            return Promise.resolve(searchResults);
        }).catch(function (error) {
            dispatch({ type: GET_SEARCH_FAILURE, error: error, searchQuery: query });
            throw error;
        });
    };
}

function updateScrollPosition() {
    var scrollPositionY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    return function (dispatch) {
        return dispatch({
            type: SEARCH_UPDATE_SCROLL_POSITION,
            scrollPositionY: scrollPositionY
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/search.js
// module id = 786
// module chunks = 0